export enum BankPaymentImportState {
  InProgress = 'in_progress',
  Completed = 'completed',
  Failed = 'failed',
}

export enum BankPaymentImportRowState {
  NotRecognized = 'not_recognized',
  Failed = 'failed',
}
